'use client';

import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { CustomButton } from '@/components/ui/CustomButton';
import { ADVISER_PORTAL } from '@/constant/external-links';

export const SideBardMobileView = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isKeyDocOpen, setIsKeyDocOpen] = useState(false);

  return (
    <div className="border-t border-b border-gray-200 mt-20 lg:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between items-center w-full py-5 text-xl font-semibold bg-white text-[#373945]"
      >
        Get Started
        <ChevronDown
          className={`h-5 w-5 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          style={{ color: '#006EB7' }}
        />
      </button>

      <div className={`bg-white ${isOpen ? 'block' : 'hidden'}`}>
        {/* Key Documents Section */}
        <div>
          <button
            onClick={() => setIsKeyDocOpen(!isKeyDocOpen)}
            className="flex justify-between items-center w-full px-4 py-2 text-xl font-medium text-[#373945]"
          >
            Key documents
            <ChevronRight
              className={`h-4 w-4 transition-transform ${isKeyDocOpen ? 'rotate-90' : ''}`}
              style={{ color: '#006EB7' }}
            />
          </button>

          <div className={`bg-white ${isKeyDocOpen ? 'block' : 'hidden'}`}>
            <div className="px-8 py-2 text-[#5B5D6B] text-lg font-medium hover:bg-gray-50">
              <a href="#product-documents">Product documents</a>
            </div>
            <div className="px-8 py-2 text-[#5B5D6B] text-lg font-medium hover:bg-gray-50">
              <a href="#application-documents">Application documents</a>
            </div>
            <div className="px-8 py-2 text-[#5B5D6B] text-lg font-medium hover:bg-gray-50">
              <a href="#general-documents">General documents</a>
            </div>
          </div>
        </div>

        {/* Regular menu items */}
        <div className="px-4 py-2 text-xl font-medium text-[#373945] hover:bg-gray-50">
          <a href="#loan">Loans</a>
        </div>

        <div className="px-4 py-2 text-xl font-medium text-[#373945] hover:bg-gray-50">
          <a href="#product-features">Features</a>
        </div>

        <div className="px-4 py-2 text-xl font-medium text-[#373945] hover:bg-gray-50">
          <a href="/professionals/contact-us" target="_blank" rel="noopener noreferrer">Contact us</a>
        </div>

        <div className="w-full px-4 py-2 pb-6 pt-6">
          <a href={ADVISER_PORTAL.CREATE_KFI} target="_blank" rel="nofollow noopener noreferrer">
            <CustomButton variant="primaryMedium" className="w-full">Create KFI</CustomButton>
          </a>
        </div>
      </div>
    </div>
  );
};
